// extracted by mini-css-extract-plugin
export default {"spinner-container":"Home_spinner-container__wjQxQ","intro":"Home_intro__GEUHn","pop-searches":"Home_pop-searches__Z1OrG","results":"Home_results__+mVUQ"};